/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'bot-type-matcher-readonly';
const prefix = `${moduleName}.${componentName}`;

export const clientTypeLabel = `${prefix}.clientTypeLabel`;

export const ENGLISH = {
    [clientTypeLabel]: 'Client Type',
};
